module.exports = __webpack_public_path__ + "img/vip-banner-bg.e6039b29.png";